export default "__VITE_ASSET__Cc1LZI7v__"